/**
 * Admin 路由守卫
 *
 * 未登录跳转到 /login。
 */

import { ReactNode, useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAdminStore } from '@/store/useAdminStore'

interface RequireAdminAuthProps {
  children: ReactNode
}

/**
 * Admin 路由守卫组件
 *
 * store 初始状态从 localStorage 同步读取，首屏即可判断认证状态。
 */
export function RequireAdminAuth({ children }: RequireAdminAuthProps) {
  const { isAuthenticated, loadFromStorage } = useAdminStore()
  const location = useLocation()

  useEffect(() => {
    loadFromStorage()
  }, [loadFromStorage])

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  return <>{children}</>
}

export default RequireAdminAuth
